import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import { BiArrowFromTop } from "react-icons/bi";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import { BsArrowUp } from "react-icons/bs";

const PromotionPreviewCard = ({ offerData }) => {
  const [isOnViewDetails, setIsOnViewDetails] = useState(false);

  const formatDate = () => {
    const date = new Date(offerData?.gameTime);
    const day = date.toLocaleString("en-US", { weekday: "short" });
    const month = date.toLocaleString("en-US", { month: "short" });
    const ordinal =
      date.getDate() +
      (["th", "st", "nd", "rd"][
        (date.getDate() % 10 > 3 || ~~(date.getDate() % 100 / 10) === 1)
          ? 0
          : date.getDate() % 10
      ] || "th");
    const time = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    return `${day} ${month} ${ordinal} ${time}`;
  };

  return (
    <Box
      sx={{
        justifyContent:'center',
        alignItems:'center',
        background: "linear-gradient(to right, #242329, #28262e)",
        color: "#fff",
        p: 2,
        borderRadius: 2,
        maxWidth: 480,
        height: 'auto',
        mb:2
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
             src={offerData?.sponsorDetails?.logoUrl}
            alt="League"
            style={{ width: 20, height: 20 }}
          />
          <Typography variant="body2" fontWeight="700">
            {offerData?.leagueName ?? "--"}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="caption" color="#ffffff">
            Presented By
          </Typography>
          <img
            src={offerData?.sponsorDetails?.logoUrl}
            alt="Sponsor"
            style={{ width: 29, height: 29, borderRadius: "50%" }}
          />
        </Box>
      </Box>

      {/* Teams & Date */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Box>
          <Typography variant="body2">{formatDate()}</Typography>
          <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
            <Box sx={{ p: 0.5, bgcolor: "#ffffff40", borderRadius: 1 }}>
              <Typography>{offerData?.teamKey}</Typography>
            </Box>
            <Typography>V.</Typography>
            <Box sx={{ p: 0.5, bgcolor: "#ffffff40", borderRadius: 1 }}>
              <Typography>{offerData?.opponentTeamKey}</Typography>
            </Box>
          </Box>
        </Box>

        <Box>
          <Box
            sx={{
              bgcolor: "#70AA2C",
              p: 1,
              borderRadius: 1,
              color: "white",
            }}
          >
            <Typography>{offerData?.teamKey} To Win</Typography>
          </Box>
        </Box>
      </Box>

      {/* Middle Section */}
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <img
          src={offerData?.sponsorDetails?.imageUrl}
          alt="Promo"
          style={{ width: "60%", height: 100, objectFit: "contain" }}
        />
        <Box sx={{ textAlign: "center", width: "40%" }}>
          <Typography color="#70AA2C" fontWeight="700">
            {offerData?.title ?? "--"}
          </Typography>
          <Typography>{offerData?.description ?? "--"}</Typography>
        </Box>
      </Box>

      <Divider sx={{ mb: 1 }} />

      {/* Footer */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box>
        <IconButton onClick={() => setIsOnViewDetails(!isOnViewDetails)} sx={{ color: "#fff" }}>
          {isOnViewDetails ?  <BsArrowUp />: <ArrowDropDownIcon /> }
        </IconButton>

        <Typography variant="caption">
          {offerData?.capacityLimit} / {offerData?.sponsorDetails?.maxParticipantsLimit ?? "--"}
        </Typography>
          </Box>
       

        <Button
          variant="contained"
          sx={{
            bgcolor: "#70AA2C",
            borderRadius: "50px",
            textTransform: "none",
            height: 44,
            width: 150,
          }}
        >
          Join Giveaway
        </Button>
      </Box>

      {/* Details Section */}
      {isOnViewDetails && (
        <Box sx={{ mt: 2 }}>
          <Typography align="center" variant="body2">
            You'll <span style={{ color: "#70AA2C" }}>Win</span> if:
          </Typography>
          <Typography align="center" variant="caption">
            The - {offerData?.teamName ?? "--"} ({offerData?.teamKey ?? "--"}) - win the game
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PromotionPreviewCard;
